import { render, staticRenderFns } from "./ChangeMail.vue?vue&type=template&id=99c4efb8&scoped=true&lang=pug&"
import script from "./ChangeMail.vue?vue&type=script&lang=js&"
export * from "./ChangeMail.vue?vue&type=script&lang=js&"
import style0 from "./ChangeMail.scss?vue&type=style&index=0&id=99c4efb8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99c4efb8",
  null
  
)

export default component.exports